import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { NavController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Device} from "@capacitor/device";

@Component({
  selector: "info-header",
  templateUrl: "./info-header.component.html",
  styleUrls: ["./info-header.component.scss"]
})
export class InfoHeaderComponent implements OnInit {
  @Input()
  hasEditButton: boolean;
  @Input()
  hasBackButton: boolean;
  @Input()
  hasHomeButton: boolean;

  @Input()
  helpLink: string;

  displayAppStore = false;

  @Output() backClicked = new EventEmitter();
  @Output() editClicked = new EventEmitter();
  @Output() homeClicked = new EventEmitter();

  constructor(public nav: NavController, private translateService:TranslateService) {
    Device.getInfo().then(deviceInfo => {
      // console.log("deviceInfo", deviceInfo);
      if ((deviceInfo.operatingSystem == "ios" || deviceInfo.operatingSystem == "android") && deviceInfo.platform == "web") {
        // console.log("display app store", deviceInfo.operatingSystem, deviceInfo.platform);
        this.displayAppStore = true;
      }
    });
  }

  ngOnInit() {}

  onBackClicked(): void {
    this.backClicked.emit();
  }
  onEditClicked(): void {
    // console.log("edit clicked");
    this.editClicked.emit();
  }
  onHelpClicked(): void {
    window.open(this.translateService.instant('userGuide.links.'+this.helpLink), "_blank");
  }
  onHomeClicked(): void {
    this.homeClicked.emit();
  }

  onAppStoreClick(): void {
    window.open("market://details?id=com.latourneedesproducteurs", "_system");
  }
}
